export default {
  IE: 11,
  Chrome: 30,
  Safari: 5,
  Opera: 12,
  Firefox: 27
};



// WEBPACK FOOTER //
// ./src/App/browserSupport.jsx